import { Injectable } from "@angular/core";
import { MetaModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { InternshipDetailsModel } from "common/models/page-models/internship-detail/internship-detail-data.model";
import { InternshipDetailsMetaModel } from "common/models/page-models/internship-detail/internship-detail-form-meta.model";
import { InternshipDetailsFormDataService } from "common/services/data-services/admin/students/internship-details-form-data-service";
;



@Injectable({
    providedIn: 'root'
})

export class InternshipDetailsFormWidgetService extends FormWidgetService<InternshipDetailsModel> {
    constructor(protected ds: InternshipDetailsFormDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new InternshipDetailsMetaModel();
        return meta.getMetaModel();
    }
}

